import { type AxiosRequestConfig } from 'axios'
import { ReferenceItem } from '../server/references/post'

interface IOptions {
  query?: string
  all?: boolean
}

const getReference = (
  type: string,
  options?: IOptions,
  dependencies?: { [key: string]: ReferenceItem }
): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: `/references/${type}`,
    data: {
      ...(options || {}),
      dependencies
    }
  }
}

export { getReference }
